import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import {
  AccordionDetailsLayout,
  FormControlLayout,
  InputFieldAccordion,
} from "./AddPatientGroup.style";
import { useTranslation } from "hhn-commons";
import * as React from "react";
import { ILupaData } from "@home-health-notify/domain";

type LupaFieldProps = {
  lupaData: ILupaData;
  onLupaDataChange: (key: string, value: string) => void;
};
export const LupaField = ({ lupaData, onLupaDataChange }: LupaFieldProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChangeAccordion =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <FormControlLayout>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChangeAccordion("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography>{tNs("lupaTitle")}</Typography>
        </AccordionSummary>
        <AccordionDetailsLayout>
          <InputFieldAccordion
            id="1st 30 days"
            label={tNs("firstThirtyDays")}
            type="text"
            variant="standard"
            value={lupaData.firstSession ?? ""}
            onChange={e => {
              onLupaDataChange("firstSession", e.target.value);
            }}
            slotProps={{
              htmlInput: {
                "data-testid": "first-session",
                maxLength: 3,
              },
            }}
          />
          <InputFieldAccordion
            id="2nd 30 days"
            label={tNs("secondThirtyDays")}
            type="text"
            variant="standard"
            value={lupaData.secondSession ?? ""}
            onChange={e => {
              onLupaDataChange("secondSession", e.target.value);
            }}
            slotProps={{
              htmlInput: {
                "data-testid": "second-session",
                maxLength: 3,
              },
            }}
          />
        </AccordionDetailsLayout>
      </Accordion>
    </FormControlLayout>
  );
};
